import { Localidad, Provincia } from "../../../services/gob-ar"
import { ActionType, CommonAction } from './actionTypes'

export type CommonState = {
    provinces: Provincia[],
    localities: Localidad[]
}

const initialState: CommonState = {
    provinces: [],
    localities: []
}

const reducer = (state = initialState, action: CommonAction) => {
    switch(action.type) {
        case ActionType.SET_PROVINCES:
            return {
                ...state,
                provinces: action.payload
            }
        case ActionType.SET_LOCALITIES:
            return {
                ...state,
                localities: action.payload
            }
        default:
            return state
    }
}

export default reducer
